import { RadioButton } from '@uikit';

import { HOT_OFFERS_SORT, HotOffersSortValue } from '@api';

export interface HotOffersFiltersProps {
  sortBy: HotOffersSortValue;
  onSortByChange: (value: HotOffersSortValue) => void;
}

const sortOptions = [
  {
    label: 'All',
    value: HOT_OFFERS_SORT.NEW,
  },
  {
    label: 'Free to Join',
    value: HOT_OFFERS_SORT.SOQUEST,
  },
  {
    label: 'Exclusive Rewards',
    value: HOT_OFFERS_SORT.GENERAL,
  },
  {
    label: 'Token Cashback',
    value: HOT_OFFERS_SORT.CASHBACK,
  },
  // Note: there is a possibility of future
  // {
  //   label: 'PoW Offers',
  //   value: HOT_OFFERS_SORT.POW,
  // },
];

export default function HotOffersFilters({ sortBy, onSortByChange }: HotOffersFiltersProps) {
  return (
    <div className="w-full flex flex-col flex-grow flex-wrap gap-4 mb-5 sm:flex-row">
      <p className="t-button">Filter by:</p>

      <div className="flex flex-grow flex-wrap gap-4">
        {sortOptions.map(({ label, value }) => {
          return (
            <RadioButton
              key={value}
              name="sort"
              label={label}
              checked={sortBy === value}
              value={value}
              onChange={() => onSortByChange(value)}
              indicatorClassName="text-secondary-600"
              labelClassName="t-caption1 text-neutral-500"
            />
          );
        })}
      </div>
    </div>
  );
}
